<template>
  <v-app>
    <v-toolbar id="toolbar" app scroll-off-screen>
      <router-link to="/">
        <v-toolbar-title class="headline">
          <span class="font-weight-regular grey--text text--darken-3">Diptanshu Kakwani</span>
        </v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn id="buttons" class="subheading" flat to="/research">Research</v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn id="buttons" class="subheading" flat v-on="on">Blog</v-btn>
          </template>
          <v-list dense>
            <v-list-tile to="/tech-blog">
              Technical
            </v-list-tile>

            <v-list-tile to="/non-tech-blog">
              Non-technical
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn id="buttons" class="subheading" flat to="/about">About Me</v-btn>
        <v-btn id="buttons" class="subheading" flat to="/contact">Contact</v-btn>
      </v-toolbar-items>
      <v-menu class="hidden-md-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list>
           <v-list-tile to="/research">
              Research
            </v-list-tile>
           <v-list-tile to="/tech-blog">
              Technical Blog
            </v-list-tile>
           <v-list-tile to="/non-tech-blog">
              Non-Technical Blog
            </v-list-tile>
           <v-list-tile to="/about">
              About Me
            </v-list-tile>
           <v-list-tile to="/contact">
              Contact
            </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <div id="page" v-bind:style="{ 'background-image': this.$BackgroundURL }">
      <v-content id="container">
        <v-card flat light>
          <router-view></router-view>
        </v-card>
      </v-content>
      <Footer id="footer"/>
    </div>
  </v-app>
</template>

<script>
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    Footer
  },
  data: function() {
    return {
      //
    };
  }
};
</script>
<style>
a {
  text-decoration: none;
}
#page {
  /* height: 100%; */
  min-height: 100%;
  background-repeat: repeat;
}
#container {
  background-color: #ffffff;
  min-height: 85%;
  margin: 3%;
}
#buttons {
  font-family: "Roberto";
}
#footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  color:#000000;
}
</style>
